import React from 'react'
import Group from 'components/utils/Group'
import Heading from 'components/Luxkit/Typography/Heading'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Clickable from 'components/Common/Clickable/Clickable'

interface Props {
  onResetFilter?: () => void;
}

function UserReviewEmptyState(props: Props) {
  const { onResetFilter } = props

  return (
    <Group fullWidth direction="vertical" horizontalAlign="center" gap={4}>
      <Heading variant="heading6">Sorry, there are no reviews for your selection</Heading>
      <BodyText variant="medium">
        Please try adjusting your filters below or
        {' '}
        <Clickable onClick={onResetFilter}>
          <BodyText variant="medium" weight="bold">show all reviews</BodyText>
        </Clickable>
      </BodyText>
    </Group>
  )
}

export default UserReviewEmptyState
